import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FutureProofBuildingEnvelopes from "./sections/FutureProofBuildingEnvelopes";
import UnsereKernleistungen from "./sections/UnsereKernleistungen";
import DasBlauMeisterVersprechen from "./sections/DasBlauMeisterVersprechen";
import SpezialisierungNachBranchen from "./sections/SpezialisierungNachBranchen";
import ReadyForProject from "./sections/ReadyForProject";
import Footer from "@/reusable_sections/Footer";
import SalesBoost from "./sections/SalesBoost";
export default function HomePage() {
  return <div>
      <Header />
      <FutureProofBuildingEnvelopes />
      <UnsereKernleistungen />
      <DasBlauMeisterVersprechen />
      <SpezialisierungNachBranchen />
      <SalesBoost />
      <ReadyForProject />
      <Footer />
    </div>;
}